module.exports = __webpack_public_path__ + "img/kh.61a4b374.svg";